import { useState, useEffect } from "react";
import apiService from "../../../services/api";

const initialFormState = {
  name: '',
  version: '1',
  content: '',
  isActive: false,
};

const PromptTemplateAddModal = ({
  showCreateModal,
  handleCloseModal,
  onTemplateCreated,
  systemPromptKey = null,
  systemPromptName = null,
  systemPromptContent = null,
}) => {
  const [formData, setFormData] = useState({ ...initialFormState });

  const isSystem = Boolean(systemPromptKey);

  useEffect(() => {
    if (showCreateModal && isSystem) {
      setFormData({
        name: systemPromptName || systemPromptKey,
        version: '2',
        content: systemPromptContent || '',
        isActive: false,
      });
    } else if (showCreateModal && !isSystem) {
      setFormData({ ...initialFormState });
    }
  }, [showCreateModal, isSystem, systemPromptKey, systemPromptName, systemPromptContent]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const payload = {
        name: formData.name.trim(),
        version: Number(formData.version),
        content: formData.content.trim(),
        isActive: formData.isActive,
      };

      if (isSystem) {
        payload.promptKey = systemPromptKey;
        payload.category = 'system';
      }

      const response = await apiService.createPromptTemplate(payload);

      if (response?.success) {
        handleCloseModal();
        setFormData({ ...initialFormState });
        onTemplateCreated();
      } else {
        window.alert(response?.message || 'Failed to create template');
      }
    } catch (error) {
      console.error('Error creating prompt template:', error);
      window.alert(
        error.response?.data?.message || 'Failed to create template'
      );
    }
  };

  return showCreateModal && (
    <div className="user-home-layout__modal-overlay" onClick={handleCloseModal}>
      <div
        className="user-home-layout__modal"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="user-home-layout__modal-header">
          <h2 className="user-home-layout__modal-title">
            {isSystem ? 'New System Prompt Version' : 'Add New Template'}
          </h2>
          <button
            type="button"
            className="user-home-layout__modal-close"
            onClick={handleCloseModal}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="user-home-layout__modal-body">
            {isSystem && (
              <div className="user-home-layout__form-group">
                <label>Prompt Key</label>
                <code style={{
                  padding: '8px 12px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#7c3aed',
                  fontSize: '13px',
                  fontFamily: "'Courier New', monospace",
                  border: '1px solid rgba(139, 92, 246, 0.15)',
                }}>
                  {systemPromptKey}
                </code>
              </div>
            )}

            <div className="user-home-layout__form-group">
              <label htmlFor="template-name">Template Name *</label>
              <input
                id="template-name"
                type="text"
                value={formData.name}
                onChange={(event) =>
                  setFormData({ ...formData, name: event.target.value })
                }
                placeholder="Enter template name"
                required
                readOnly={isSystem}
              />
            </div>

            <div className="user-home-layout__form-group">
              <label htmlFor="template-version">Version *</label>
              <input
                id="template-version"
                type="number"
                min={1}
                value={formData.version}
                onChange={(event) =>
                  setFormData({ ...formData, version: event.target.value })
                }
                required
              />
            </div>

            <div className="user-home-layout__form-group">
              <label htmlFor="template-content">Content *</label>
              <textarea
                id="template-content"
                rows={6}
                value={formData.content}
                onChange={(event) =>
                  setFormData({ ...formData, content: event.target.value })
                }
                placeholder="Provide the prompt instructions to execute."
                required
              />
            </div>

            <div className="user-home-layout__form-group user-home-layout__form-group--checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={formData.isActive}
                  onChange={(event) =>
                    setFormData({ ...formData, isActive: event.target.checked })
                  }
                />
                <span>Mark as active</span>
              </label>
            </div>
          </div>

          <div className="user-home-layout__modal-footer">
            <button
              type="button"
              className="user-home-layout__action-button user-home-layout__action-button--secondary"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="user-home-layout__action-button user-home-layout__action-button--primary"
            >
              {isSystem ? 'Create Version' : 'Save Template'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PromptTemplateAddModal;
